import { render } from "./StoragePathTooltip.vue?vue&type=template&id=9d2fb3ce&ts=true"
import script from "./StoragePathTooltip.vue?vue&type=script&lang=ts"
export * from "./StoragePathTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__